import classNames from "classnames";

import { TextInput } from "components/UI/TextInput/TextInput";
import { useMatchMedia } from "utils/hooks/use-match-media";

import "./InputLink.scss";

export default function InputLink({ placeholder = '', className, value, onChange, errortext }) {
  const { isMobile } = useMatchMedia();

  const placeholderVariant = isMobile
    ? "Укажите ссылку"
    : "Укажите ссылку формата https://";

  return (
    <TextInput
      className={classNames("input-link", className)}
      placeholder={placeholder || placeholderVariant}
      value={value}
      onChange={onChange}
      errortext={errortext}
    />
  );
}
